import WarningBanner from "@memorang/ui/src/components/WarningBanner";
import { Messages } from "./Messages";
import { Popup } from "./Popup";
import { Textarea } from "./Textarea";

export const RedeemCopilotChat = ({
	greetingMessage,
	warningMessage,
}: {
	greetingMessage?: string;
	warningMessage?: string;
}) => {
	return (
		<Popup greetingMessage={greetingMessage}>
			{warningMessage && (
				<WarningBanner message={warningMessage} iconSize={28} />
			)}
			<Messages />
			<Textarea />
		</Popup>
	);
};
